import { object, string, InferType, number } from 'yup'
import { useFormContext } from '../context/FormContext'
import { Box, Slider, TextField } from '@mui/material'

export enum LanguageSkills {
    None,
    BASIC,
    INTERMEDIATE,
    ADVANCED,
    Professional,
}

const sliderMarks = [
    {
        value: 0,
        // label: 'None',
    },
    {
        value: 1,
        // label: 'Beginner',
    },
    {
        value: 2,
        // label: 'Intermediate',
    },
    {
        value: 3,
        // label: 'Advanced',
    },
    {
        value: 4,
        // label: 'Professional',
    },
];

export const languageSchema = object({
    arabic: number().required().min(0).max(4),
    english: number().required().min(0).max(4),
    french: number().required().min(0).max(4),
    italian: number().required().min(0).max(4),
    additionalLanguages: string(),
})

export interface LanguageData extends InferType<typeof languageSchema> { }

const LanguagesScreen = () => {

    const {
        formData, formik, labels
    } = useFormContext()

    const { english, arabic, french, italian, additionalLanguages } = formData

    if (!formik) {
        return null
    }

    const { handleChange, handleBlur, touched, errors } = formik

    return (
        <Box width="100%" className="screen-language" sx={{ 'label': { fontSize: '16px', '@media (min-width: 1024px)': { fontSize: '18px' } } }}>
            <div className="react-form-title">
                <h2>{labels.languages.title}</h2>
            </div>
            <Box display="flex"  className="language-slider" pb="20px">
                <Box width="150px"><label id="arabic-slider-label"> {labels.languages.arabic} </label></Box>
                <Box width="100%" ml="80px">
                    <Slider
                        id="arabic-slider"
                        min={0}
                        max={4}
                        value={arabic}
                        onChange={handleChange}
                        name='arabic'
                        marks={sliderMarks}
                        size='small'
                        aria-labelledby='arabic-slider-label arabic-slider-range-start-label arabic-slider-range-end-label'
                    />
                    <Box display="flex" justifyContent="space-between">
                        <label id="arabic-slider-range-start-label">{labels.languages.none}</label>  
                        <label id="arabic-slider-range-end-label">{labels.languages.professional}</label>
                    </Box>
                </Box>
            </Box>
            <Box display="flex"  className="language-slider" pb="20px">
                <Box width="150px"><label id="english-slider-label">{labels.languages.english}</label></Box>
                <Box width="100%" ml="80px">
                    <Slider
                        id="english-slider"
                        min={0}
                        max={4}
                        value={english}
                        onChange={handleChange}
                        name='english'
                        marks={sliderMarks}
                        size='small'
                        aria-labelledby='english-slider-label english-slider-range-start-label english-slider-range-end-label'
                    />
                    <Box display="flex" justifyContent="space-between">
                        <label id="english-slider-range-start-label">{labels.languages.none}</label>
                        <label id="english-slider-range-end-label">{labels.languages.professional}</label>
                    </Box>
                </Box>
            </Box>

            <Box display="flex"  className="language-slider" pb="20px">
                <Box width="150px"><label id="french-slider-label">{labels.languages.french}</label></Box>
                <Box width="100%" ml="80px">
                    <Slider
                        id="french-slider"
                        min={0}
                        max={4}
                        value={french}
                        onChange={handleChange}
                        name='french'
                        marks={sliderMarks}
                        size='small'
                        aria-labelledby='french-slider-label french-slider-range-start-label french-slider-range-end-label'
                    />
                    <Box display="flex" justifyContent="space-between">
                        <label id="french-slider-range-start-label">{labels.languages.none}</label>
                        <label id="french-slider-range-end-label">{labels.languages.professional}</label>
                    </Box>
                </Box>
            </Box>
            <Box display="flex"  className="language-slider" pb="20px">
                <Box width="150px"><label id="italian-slider-label">{labels.languages.italian}</label></Box>
                <Box width="100%" ml="80px">
                    <Slider
                        id="english-slider"
                        min={0}
                        max={4}
                        value={italian}
                        onChange={handleChange}
                        name='italian'
                        marks={sliderMarks}
                        size='small'
                        aria-labelledby='italian-slider-label italian-slider-range-start-label italian-slider-range-end-label'
                    />
                    <Box display="flex" justifyContent="space-between">
                        <label id="italian-slider-range-start-label">{labels.languages.none}</label>
                        <label id="italian-slider-range-end-label">{labels.languages.professional}</label>
                    </Box>
                </Box>
            </Box>
            <TextField
                id="additionalLanguages"
                label={labels.languages.additionalLanguages}
                value={additionalLanguages}
                onBlur={handleBlur}
                onChange={handleChange}
                error={touched.additionalLanguages && Boolean(errors.additionalLanguages)}
                helperText={touched.additionalLanguages && errors.additionalLanguages}
                name='additionalLanguages'
                variant="standard"
                fullWidth
            />
        </Box>
    )
}

export default LanguagesScreen